import { render } from "./dashboardSider.vue?vue&type=template&id=57a2fb21"
import script from "./dashboardSider.vue?vue&type=script&lang=js"
export * from "./dashboardSider.vue?vue&type=script&lang=js"
script.render = render

export default script